<script type="ts">
	import { onMount } from 'svelte';
	import EventCourtesyRequest from './EventCourtesyRequest.svelte';
	import { storeSettings } from '../../store/StoreSettings';
	import { applyColors } from '../../utils';

	export let publicKey: string;
	export let primaryColor: string;
	export let buttonText: string;
	export let eventCode: string;
	export let invitationCode: string;
	export let ticketTypeCode: string;
	export let autoValidationCode: string;
	export let borderRadius: string;

	// storeSettings.update((publicKey) => (publicKey = publicKey));
	// storeSettings.update((primaryColor) => (primaryColor = primaryColor));
	// storeSettings.update((buttonText) => (buttonText = buttonText));
	// storeSettings.update((eventCode) => (eventCode = eventCode));
	// storeSettings.update((invitationCode) => (invitationCode = invitationCode));
	// storeSettings.update((ticketTypeCode) => (ticketTypeCode = ticketTypeCode));
	// storeSettings.update((autoValidationCode) => (autoValidationCode = autoValidationCode));

	storeSettings.set({
		publicKey: publicKey,
		primaryColor: primaryColor ? `${primaryColor}` : '#e52b51',
		buttonText: buttonText,
		eventCode: eventCode,
		invitationCode: invitationCode,
		ticketTypeCode: ticketTypeCode,
		autoValidationCode: autoValidationCode,
		borderRadius: borderRadius || false
	});

	onMount(() => {
		applyColors({ primary: primaryColor, secondary: null });
	});
</script>

<div class="cobraticket-widget">
	<EventCourtesyRequest />
</div>

<style global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	@layer utilities {
		input[type='number']::-webkit-inner-spin-button,
		input[type='number']::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
</style>
